<template>
  <div
    v-show="!janela.minimizada"
    ref="window"
    class="lead-window"
    :class="{ 'lead-window-maximized': janela.maximizada }"
    :style="windowStyle"
    @mousedown="ativar"
  >

    <div
      class="lead-window-header"
      @mousedown.prevent="iniciarArrasto"
      @dblclick="maximizar"
    >
      <div class="lead-window-title" :title="janela.nome">
        <span class="lead-window-dot"></span>
        {{ janela.nome }}
      </div>

      <div class="lead-window-actions" @mousedown.stop>
        <button type="button" title="Minimizar" @click.stop="minimizar">
          <span class="lead-icon-minimize">—</span>
        </button>

        <button
          type="button"
          :title="janela.maximizada ? 'Restaurar tamanho' : 'Maximizar'"
          @click.stop="maximizar"
        >
          <span v-if="!janela.maximizada">□</span>
          <span v-else>▣</span>
        </button>

        <button type="button" class="lead-window-close" title="Fechar" @click.stop="fechar">
          ×
        </button>
      </div>
    </div>

    <div class="lead-window-body" style="padding: 0 30px !important">
      <!--
        O Leads.vue é reutilizado integralmente. Cada janela cria uma
        instância independente com seu próprio estado e seus próprios dados.
      -->
      <Leads
        :lead-id="janela.id"
        :modo-janela="true"
      />
    </div>

  </div>
</template>

<script>
import Leads from '@/views/Leads'

export default {
  name: 'LeadWindow',

  components: {
    Leads
  },

  props: {
    janela: {
      type: Object,
      required: true
    }
  },

  data(){
    return {
      arrastando: false,
      offsetX: 0,
      offsetY: 0
    }
  },

  computed: {
    windowStyle(){
      if(this.janela.maximizada){
        return {
          zIndex: this.janela.zIndex
        }
      }

      return {
        left: this.janela.x + 'px',
        top: this.janela.y + 'px',
        width: this.janela.width + 'px',
        height: this.janela.height + 'px',
        zIndex: this.janela.zIndex
      }
    }
  },

  methods: {

    ativar(){
      this.$emit('ativar', this.janela.id)
    },

    minimizar(){
      this.$emit('minimizar', this.janela.id)
    },

    maximizar(){
      this.$emit('maximizar', this.janela.id)
    },

    fechar(){
      this.$emit('fechar', this.janela.id)
    },

    iniciarArrasto(event){

      // Não permite arrastar quando a janela está maximizada.
      if(this.janela.maximizada){
        return
      }

      // Botão direito não inicia o arrasto.
      if(event.button !== 0){
        return
      }

      this.ativar()
      this.arrastando = true

      const rect = this.$refs.window.getBoundingClientRect()

      this.offsetX = event.clientX - rect.left
      this.offsetY = event.clientY - rect.top

      document.addEventListener('mousemove', this.arrastar)
      document.addEventListener('mouseup', this.finalizarArrasto)

      document.body.classList.add('lead-window-dragging')
    },

    arrastar(event){
      if(!this.arrastando){
        return
      }

      let x = event.clientX - this.offsetX
      let y = event.clientY - this.offsetY

      // Evita que o cabeçalho desapareça completamente da tela.
      const larguraMinimaVisivel = 180
      const larguraJanela = this.janela.width || 900
      const alturaHeader = 42

      const maxX = window.innerWidth - larguraMinimaVisivel
      const maxY = window.innerHeight - alturaHeader
      const minX = -(larguraJanela - larguraMinimaVisivel)

      x = Math.max(minX, Math.min(x, maxX))
      y = Math.max(0, Math.min(y, maxY))

      this.$set(this.janela, 'x', x)
      this.$set(this.janela, 'y', y)
    },

    finalizarArrasto(){
      this.arrastando = false

      document.removeEventListener('mousemove', this.arrastar)
      document.removeEventListener('mouseup', this.finalizarArrasto)

      document.body.classList.remove('lead-window-dragging')
    }
  },

  beforeDestroy(){
    document.removeEventListener('mousemove', this.arrastar)
    document.removeEventListener('mouseup', this.finalizarArrasto)
    document.body.classList.remove('lead-window-dragging')
  }
}
</script>

<style>
.lead-window{
  position:fixed;
  display:flex;
  flex-direction:column;
  min-width:600px;
  min-height:400px;
  max-width:calc(100vw - 20px);
  max-height:calc(100vh - 20px);
  background:#fff;
  border:1px solid #a7a7a7;
  border-radius:7px;
  overflow:hidden;
  box-shadow:0 12px 35px rgba(0,0,0,.35);
}

.lead-window-maximized{
  left:10px !important;
  top:10px !important;
  width:calc(100vw - 20px) !important;
  height:calc(100vh - 20px) !important;
  max-width:none;
  max-height:none;
  border-radius:5px;
}

.lead-window-header{
  flex:0 0 42px;
  height:42px;
  display:flex;
  align-items:center;
  justify-content:space-between;
  padding-left:14px;
  background:#343a40;
  color:#fff;
  cursor:move;
  user-select:none;
}

.lead-window-title{
  display:flex;
  align-items:center;
  min-width:0;
  font-size:14px;
  font-weight:600;
  overflow:hidden;
  white-space:nowrap;
  text-overflow:ellipsis;
}

.lead-window-dot{
  width:9px;
  height:9px;
  margin-right:8px;
  border-radius:50%;
  background:#28a745;
  flex:0 0 auto;
}

.lead-window-actions{
  height:100%;
  display:flex;
  align-items:center;
}

.lead-window-actions button{
  width:42px;
  height:42px;
  padding:0;
  border:0;
  background:transparent;
  color:#fff;
  font-size:19px;
  line-height:1;
  cursor:pointer;
}

.lead-window-actions button:hover{
  background:rgba(255,255,255,.15);
}

.lead-window-actions .lead-window-close{
  font-size:25px;
}

.lead-window-actions .lead-window-close:hover{
  background:#dc3545;
}

.lead-icon-minimize{
  display:inline-block;
  transform:translateY(-3px);
}

.lead-window-body{
  flex:1 1 auto;
  overflow:auto;
  background:#fff;
  padding:15px;
}

body.lead-window-dragging,
body.lead-window-dragging *{
  cursor:move !important;
  user-select:none !important;
}
</style>
